import toLower from 'lodash/toLower'
import { PivotAggregationEnum } from '@ztechapps/common.contract'

/** Function names a pivot calculated-measure formula may call — the aggregations plus the scalar functions. */
export const PIVOT_FORMULA_FUNCTIONS = [
  ...Object.values(PivotAggregationEnum).map(toLower),
  'abs',
  'round',
  'if',
  'isNaN',
]
